import React from 'react';
import styled from 'App/styled';


const ProImage = styled.div`
  position: absolute;
  right: 0;
  z-index: 1;
`;

const ProTagSvg = () => (
  <ProImage>
    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
      <g fill="none" fillRule="nonzero">
        <path fill="#FFF" d="M0 0h45v45z" />
        <path fill="#FC2779" d="M0 0h45v45L0 0zm25.43 5.711l-4.958 4.957 1.471 1.47 1.337-1.336.777.778c1.28 1.28 2.694 1.337 3.875.156 1.125-1.125 1.026-2.496-.254-3.776L25.429 5.71zm.339 2.602l.707.707c.438.439.452.934.02 1.365-.445.446-.94.431-1.378-.007l-.707-.707 1.358-1.358zm2.44 10.09l1.668 1.67.615-2.624c.842.233 1.676-.007 2.411-.742 1.125-1.125.997-2.525-.332-3.854l-2.312-2.312-4.957 4.957 1.47 1.47 1.337-1.336.778.778-.679 1.994zM29.24 14.5l1.358-1.357.842.841c.438.439.452.934.02 1.365-.445.445-.94.431-1.378-.007l-.842-.842zm8.606 3.543c-1.556-1.556-3.762-1.64-5.218-.184-1.464 1.464-1.4 3.691.155 5.247 1.556 1.556 3.79 1.612 5.247.156 1.45-1.45 1.372-3.663-.184-5.219zm-1.21 1.252c.651.65.63 1.718-.12 2.467-.749.75-1.83.785-2.481.135-.65-.65-.658-1.775.092-2.525s1.852-.735 2.51-.077z" />
      </g>
    </svg>
  </ProImage>
);

export default ProTagSvg;
